<template>
      <b-modal 
        id="email-preview" 
        modal-class='block__email'
        hide-header-close
        modal-footer="hide"
        size= "lg"
        scrollable
        centered
        ok-only
        ok-title="Fermer"
        title="Aperçu de l'email"
        >
        <div class="email-container">
          <div class="email-wrapper">
            <header :style="`background-image:url(${backgroundImg})`"> 
              <div class="desc">
                <h1>{{title}}</h1>
                <h2>{{subtitle}}</h2>
              </div>
            </header>
            <div class="content" v-html="content">
            </div>
            <footer>
              <b-img :src="footerImg"></b-img>
            </footer>
          </div>
        </div>
      <Stack></Stack>
 

      <template v-slot:modal-footer>
      </template>

      </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Stack from '../stack/Stack';

export default {
  name: "EmailPreview",
  components: {
    Stack
  },
  props:{
    content:{
      default:'',
      type:String,
    },
    title:{
      default:'',
      type:String,
    },
    subtitle:{
      default:'',
      type:String,
    },
    backgroundImg:{
      type:String,
      default:'/img/header-email.png'
    },
    footerImg:{
      type:String,
      default:'/img/logo-footer-email.png'
    }
  },
  data() {
    return {
      isMobile:false
    }
  },
  computed: {
    ...mapGetters([
        'getGeneral',
        'getIsMobile'
    ])
  },
  created (){
    this.isMobile = this.getIsMobile;
  },  
  methods:{
      goBack() {
        this.$router.push({name: "profileCollab"});  
      },       
  },
  watch : {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
}
</script>

